import Rails from '@rails/ujs'
import documentReady from './documentReady.ts'

function optIn () {
  const checkbox = document.querySelector('#orderView #opt_in')
  if (checkbox === null) {
    return
  }
  checkbox.addEventListener('change', () => {
    const optingIn = checkbox.checked ? '1' : '0'
    Rails.ajax({
      url: `/orders/opt_in?opt_in=${optingIn}`,
      type: 'POST',
      success: function onSuccess () {
        const updatedMessage = document.querySelector('.preferences-updated')
        updatedMessage.style.display = 'block'
      }
    })
  })
}

documentReady(optIn)
